import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4a4ded6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "index",
  class: "index"
}
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Channel = _resolveComponent("Channel")!
  const _component_Statistical = _resolveComponent("Statistical")!
  const _component_Main = _resolveComponent("Main")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Channel),
    _createVNode(_component_Statistical),
    _createVNode(_component_a_config_provider, {
      locale: $data.expand.locale
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.$route.path==='/')
              ? (_openBlock(), _createBlock(_component_Main, { key: 0 }))
              : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["locale"])
  ], 64 /* STABLE_FRAGMENT */))
}